export const getFileIdsForBulkUpdate = ({ uploadedFile, uploadedFiles }) => {
  return uploadedFiles.find(item => item.id === uploadedFile.id)?.file_ids
}
